module.exports = __webpack_public_path__ + "static/media/meditime.e6b2dbd8.png";